import type { ComponentLoaderType } from '@grafikr/components';

const Loader: ComponentLoaderType = ({ node, emitter }, load) => {
  const events = node.dataset.loadEvent.split(' ');

  events.forEach((event) => {
    emitter.on(event, load);
    document.addEventListener(event, load); // Used by wishlistking
  });

  return () => {
    events.forEach((event) => {
      emitter.off(event, load);
      document.removeEventListener(event, load); // Used by wishlistking
    });
  };
};

export default Loader;
